import React from "react";
import PropTypes from "prop-types";
import { DonutChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { objectToSeries, orderBy } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { withChartData } from "../common/chart-data-hoc";
import { withChartConfig } from "../common/chart-config-hoc";
import { withRouter } from "react-router";
import { all } from "awaity/esm";
import { getCaseCount as getCaseCountPTAB } from "../../services/api-ptab";
import { getCaseCount as getCaseCountLitigation } from "../../services/api-maxval";

const COLOR_MAP = {
  Pending: Colors.orange400,
  "Not Instituted": Colors.grey400,
  "Not Ins": Colors.grey400,
  "Final Written Decision": Colors.blue500,
  FWD: Colors.blue500,
  Settlement: Colors.blue300,
  Settled: Colors.blue300,
  "Adverse Judgment": Colors.blue200,
  Adverse: Colors.blue200,
  "Procedural Termination": Colors.grey500,
  Procedural: Colors.grey500,
  "District Court": Colors.blue400,
  District: Colors.blue400,
  "Supreme Court": Colors.blue200,
  Supreme: Colors.blue200,
  "Federal Circuit": Colors.grey200,
  Circuit: Colors.grey200,
  ITC: Colors.grey400
};

const CaseCountsDonutChart = props => {
  const _onValueClick = datapoint => {
    let query = undefined;
    props.queries.forEach(q => {
      if (q[0] === datapoint.key) {
        query = q[1];
      }
    });

    props.router.push({
      pathname: props.path,
      query: query
    });
  };
  const api = queries => {
    const apiCall = props.api === "ptab" ? getCaseCountPTAB : getCaseCountLitigation;
    return all(queries.map(query => apiCall(query[1]))).then(counts => {
      let results = {};
      for (var i = 0; i < counts.length; i++) {
        results[queries[i][0]] = counts[i];
      }
      return results;
    });
  };
  const dataFormatter = data =>
    orderBy(
      objectToSeries(data),
      props.queries.map(q => q[0])
    );
  const Chart = withChartConfig(withChartData(makeWidthFlexible(DonutChart), api, props.queries));
  return (
    <Chart
      title={props.title}
      dataFormatter={dataFormatter}
      colorMap={COLOR_MAP}
      height={282}
      margin={{ top: 16, bottom: 16, left: 16, right: 16 }}
      path={props.path}
      onValueClick={_onValueClick}
      scrollable={false}
      {...props}
    />
  );
};

CaseCountsDonutChart.propTypes = {
  queries: PropTypes.arrayOf(PropTypes.array).isRequired, // array of tuples (name, query)
  api: PropTypes.string.isRequired,
  title: PropTypes.string,
  path: PropTypes.string
};

export default withRouter(CaseCountsDonutChart);
